// @flow
import { DISMISS_MODAL, OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL, OPEN_SEND_SELLER_MESSAGE_MODAL } from './modal';
import api from '../api/seller';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const SEND_SELLER_MESSAGE_FAIL = 'la/ui/sendSellerMessage/FAIL';
export const SEND_SELLER_MESSAGE_REQUEST = 'la/ui/sendSellerMessage/REQUEST';
export const SEND_SELLER_MESSAGE_SUCCESS = 'la/ui/sendSellerMessage/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return {
                ...state,
                messageDetails: action.payload.messageDetails,
                sellerId: action.payload.sellerId,
                sellerName: action.payload.sellerName,
                subject: action.payload.subject,
                title: action.payload.title,
            };
        case SEND_SELLER_MESSAGE_REQUEST:
            return {
                ...state,
                error: false,
                submitted: true,
                success: false,
            };
        case DISMISS_MODAL:
            return {
                ...state,
                success: false,
            };
        case SEND_SELLER_MESSAGE_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case SEND_SELLER_MESSAGE_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.sendSellerMessage;

export const getUiSendSellerMessage = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitSendSellerMessage = (messageDetails: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: SEND_SELLER_MESSAGE_REQUEST,
        });
        const response = await api.postMessage({ authToken, deployment, messageDetails });
        dispatch({
            payload: response,
            type: SEND_SELLER_MESSAGE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: SEND_SELLER_MESSAGE_FAIL,
        });
    }
};
